import React, { createContext, useCallback, useContext, useState } from "react";

import {
  PasswordRecoveryContextValue,
  PasswordRecoveryProviderProps,
  TruncatedInfo,
  TruncatedInfoContextValue,
} from "./PasswordRecoveryContext.types";

const IdentifierRecoveryContext =
  createContext<PasswordRecoveryContextValue | null>(null);
const TruncatedInfoContext = createContext<TruncatedInfoContextValue | null>(
  null
);

export const PasswordRecoveryProvider = ({
  children,
}: PasswordRecoveryProviderProps) => {
  const [identifier, setIdentifierState] = useState("");
  const [truncatedInfo, setTruncatedInfo] = useState<TruncatedInfo | null>(
    null
  );

  const setIdentifier = useCallback((value: string) => {
    setIdentifierState((previousIdentifier) => {
      if (previousIdentifier !== value) {
        setTruncatedInfo(null);
      }

      return value;
    });
  }, []);

  return (
    <IdentifierRecoveryContext.Provider value={{ identifier, setIdentifier }}>
      <TruncatedInfoContext.Provider
        value={{ setTruncatedInfo, truncatedInfo }}
      >
        {children}
      </TruncatedInfoContext.Provider>
    </IdentifierRecoveryContext.Provider>
  );
};

export const useIdentifierRecoveryContext =
  (): PasswordRecoveryContextValue => {
    const context = useContext(IdentifierRecoveryContext);
    if (!context) {
      throw new Error(
        "useIdentifierRecoveryContext must be used within a PasswordRecoveryProvider"
      );
    }
    return context;
  };

export const useTruncatedInfoContext = (): TruncatedInfoContextValue => {
  const context = useContext(TruncatedInfoContext);
  if (!context) {
    throw new Error(
      "useTruncatedInfoContext must be used within a PasswordRecoveryProvider"
    );
  }
  return context;
};
